(ns manage.adset-decision-tree-page.auto-generate-trackers-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/x-data-grid-premium" :refer [useGridApiContext]]
            [cljs-bean.core :refer [->clj]]
            [common.ocp.view :refer [defocp ocp]]
            [manage.adset-decision-tree-page.auto-generate-trackers-ocp.hook :as hook]
            [manage.adset-decision-tree-page.view.common :refer [id-input]]
            [manage.adset-decision-tree-page.view.tracker-table :refer [tracker-table]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(def ^:private submitted-ctx (uix/create-context false))

(defn- validate-required [v] (when-not (seq v) "Required"))

(defui ^:memo text-edit-cell [{:keys [compact-view]
                               {:keys [id value field hasFocus]} :params}]
  (let [submitted (uix/use-context submitted-ctx)
        {{:keys [setEditCellValue]} :current} (->clj (useGridApiContext))
        [local-value set-local-value] (uix/use-state nil)
        [has-on-blur set-has-on-blur] (uix/use-state false)
        handle-change (fn [new-value]
                        (set-local-value new-value)
                        (setEditCellValue #js {:id id :field field
                                               :value new-value :debounceMs 200}))
        error (when (or submitted has-on-blur) (validate-required local-value))]
    (uix/use-effect (fn [] (set-local-value value)) [value])
    ($ TextField {:value (or local-value "")
                  :placeholder "Paste placement name"
                  :size "small"
                  :fullWidth true
                  :variant "outlined"
                  :autoFocus hasFocus
                  :sx #js {:px (when-not compact-view 2)}
                  :error (boolean error)
                  :helperText error
                  :onChange #(handle-change (.. % -target -value))
                  :onBlur #(set-has-on-blur true)})))

(def cm360-columns
  [{:field "placement-name"
    :headerName "Placement name"
    :flex 2
    :sortable false
    :disableColumnMenu true
    :editable true
    :renderCell #($ text-edit-cell {:params (->clj %) :compact-view true})
    :renderEditCell #($ text-edit-cell {:params (->clj %)})}])

(defui cm360-selection-panel
  [{:keys [control campaign-options site-options campaigns-loading sites-loading]}]
  ($ Stack {:spacing 2 :sx #js {:pb 1 :maxWidth "45rem"}}
     ($ id-input {:name "campaign-id"
                  :label "CM360 Campaign"
                  :placeholder "Input your CM360 campaign"
                  :required true
                  :rules #js {:required "Required"}
                  :control control
                  :loading campaigns-loading
                  :ids-with-description campaign-options})
     ($ id-input {:name "site-id"
                  :label "CM360 Site"
                  :placeholder "Input your CM360 site"
                  :required true
                  :rules #js {:required "Required"}
                  :control control
                  :loading sites-loading
                  :ids-with-description site-options})))

(defui footer [{:keys [on-save]}]
  ($ Stack {:direction "row" :spacing 1 :justifyContent "flex-end"}
     ($ Button {:variant "outlined"
                :onClick #(rf/dispatch [:ocp/close])}
        "Cancel")
     ($ Button {:variant "contained"
                :onClick on-save}
        "Save")))

(defocp ocp-view ::ocp {:width "80%"} []
  (let [{:keys [table-controls selection-controls on-save submitted]} (hook/use-ocp-controls)]
    ($ ocp {:title "Auto-Generate Trackers"
            :footer ($ footer {:on-save on-save})}
       ($ Stack {:spacing 2 :sx #js {:height "100%"}}
          ($ cm360-selection-panel selection-controls)
          ($ Divider)
          ($ submitted-ctx {:value submitted}
             ($ tracker-table (assoc table-controls :extra-columns cm360-columns)))))))
